import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  cancelEarningDetails,
  earning,
  earningTeacher,
  earningDetails,
  fetchSetting,
  saveFeeSettings,
  studentWiseEarningDetails,
  getMembershipPurchasesApi,
  getEventPurchasesApi,
  getClassPurchasesApi,
  getExpenseDetailsApi,
  getArchivedFinanceReports,
  deleteArchivedFinanceReport
} from "../../api/payment";
import { toast } from "react-toastify";

const initialState = {
  list: [],
  list_teacher: [],
  detail: null,
  adminPercent: 0,
  teacher: null,
  setting: null,
  venues:[],
  archivedReports: []
};

export const payment = createSlice({
  name: "paymentSlice",
  initialState,
  reducers: {
    listing: (state, action) => {
      state.list = action.payload;
    },
    listingTeacher: (state, action) => {
      state.list_teacher = action.payload;
    },
    details: (state, action) => {
      state.item_detail = action.payload;
    },
    itemDetail: (state, action) => {
      state.itemDetail = action.payload;
    },
    totalCount: (state, action) => {
      state.total = action.payload;
    },
    adminPercentile: (state, action) => {
      state.adminPercent = action.payload;
    },
    teacher: (state, action) => {
      state.teacher = action.payload;
    },
    setting: (state, action) => {
      state.setting = action.payload;
    },
    venueList: (state, action) => {
      state.venues = action.payload;
    },
    archivedReportsList: (state, action) => {
      state.archivedReports = action.payload;
    },
  },
});

export const FetchEarnings = createAsyncThunk(
  "earnings",
  async (obj, { dispatch }) => {
    try {
      const response = await earning(obj);
      if (response?.code === 1) {
        console.log(response, "Earnings");
          dispatch(listing(response?.data?.earning_list));
        // dispatch(totalCount(response?.data?.total_earning));
        // dispatch(adminPercentile(response?.data?.admin_percentage));
      }
      return response;
    } catch (error) {
      toast.error(error.message, {  autoClose: false,  closeButton: true});
    }
  }
);

export const FetchSetting = createAsyncThunk(
  "setting",
  async (obj, { dispatch }) => {
    try {
      const response = await fetchSetting(obj);
      if (response?.code === 1) {
        console.log(response, "Setting");
        // Dispatch the entire data object which includes settings, venue_hall_fees, and subscription
        dispatch(setting(response?.data));
      }
      return response;
    } catch (error) {
      toast.error(error.message, {  autoClose: false,  closeButton: true});
    }
  }
);

export const SaveFeeSettings = createAsyncThunk(
  "saveFeeSettings",
  async (obj, { dispatch }) => {
    try {
      const response = await saveFeeSettings(obj);
      if (response?.code === 1) {
        toast.success(response?.message || "Settings saved successfully");
      } else {
        toast.error(response?.message || "Failed to save settings", {  autoClose: false,  closeButton: true});
      }
      return response;
    } catch (error) {
      toast.error(error.message, {  autoClose: false,  closeButton: true});
    }
  }
);

export const FetchTeacherEarnings = createAsyncThunk(
  "TeacherEarnings",
  async (obj, { dispatch }) => {
    try {
      const response = await earningTeacher(obj);
      if (response?.code === 1) {
        console.log(response, "TeacherEarnings");
          dispatch(listingTeacher(response?.data?.earning_list));
        // dispatch(totalCount(response?.data?.total_earning));
        // dispatch(adminPercentile(response?.data?.admin_percentage));
      }
      return response;
    } catch (error) {
      toast.error(error.message, {  autoClose: false,  closeButton: true});
    }
  }
);

export const FetchEarningDetails = createAsyncThunk(
  "earnings",
  async (obj, { dispatch }) => {
    try {
      const response = await earningDetails(obj);
      if (response?.code === 1) {
        console.log(response, "Earning details");
        dispatch(details(response?.data?.earning_details));
        dispatch(teacher(response?.data?.teacher));
      }
      return response;
    } catch (error) {
      toast.error(error.message, {  autoClose: false,  closeButton: true});
    }
  }
);
export const FetchStudentWiseEarningDetails = createAsyncThunk(
  "studentWiseEarnings",
  async (obj, { dispatch }) => {
    try {
      const response = await studentWiseEarningDetails(obj);
      if (response?.code === 1) {
        console.log(response, "Student Wise Earning details");
        dispatch(details(response?.data?.earning_details));
        dispatch(teacher(response?.data?.teacher));
      }
      return response;
    } catch (error) {
      toast.error(error.message, {  autoClose: false,  closeButton: true});
    }
  }
);
export const FetchCancelledEarningDetails = createAsyncThunk(
  "cancelled earnings",
  async (obj, { dispatch }) => {
    try {
      const response = await cancelEarningDetails(obj);
      if (response?.code === 1) {
        console.log(response, "Earning details");
        dispatch(details(response?.data?.earning_details));
      }
      return response;
    } catch (error) {
      toast.error(error.message, {  autoClose: false,  closeButton: true});
    }
  }
);

export const getMembershipPurchases = createAsyncThunk(
  "getMembershipPurchases",
  async (obj, { dispatch }) => {
    try {
      const response = await getMembershipPurchasesApi(obj);
      if (response?.code === 1) {
        console.log(response, "Membership Purchases");
        dispatch(itemDetail(response?.data?.earning_list));
      }
      return response;
    } catch (error) {
      toast.error(error.message, {  autoClose: false,  closeButton: true});
    }
  }
);
export const getEventPurchases = createAsyncThunk(
  "getEventPurchases",
  async (obj, { dispatch }) => {
    try {
      const response = await getEventPurchasesApi(obj);
      if (response?.code === 1) {
        console.log(response, "Event Purchases");
        dispatch(itemDetail(response?.data?.event_purchases));
      }
      return response;
    } catch (error) {
      toast.error(error.message, {  autoClose: false,  closeButton: true});
    }
  }
);
export const getClassPurchases = createAsyncThunk(
  "getClassPurchases",
  async (obj, { dispatch }) => {
    try {
      const response = await getClassPurchasesApi(obj);
      if (response?.code === 1) {
        console.log(response, "Class Purchases");
        dispatch(itemDetail(response?.data?.class_purchases));
      }
      return response;
    } catch (error) {
      toast.error(error.message, {  autoClose: false,  closeButton: true});
    }
  }
);
export const getExpenseDetails = createAsyncThunk(
  "getExpenseDetails",
  async (obj, { dispatch }) => {
    try {
      const response = await getExpenseDetailsApi(obj);
      if (response?.code === 1) {
        console.log(response, "Expense Details");
        dispatch(itemDetail(response?.data?.expense_details));
      }
      return response;
    } catch (error) {
      toast.error(error.message, {  autoClose: false,  closeButton: true});
    }
  }
);

export const FetchArchivedReports = createAsyncThunk(
  "archivedReports",
  async (company_id, { dispatch }) => {
    try {
      const response = await getArchivedFinanceReports(company_id);
      if (response?.code === 1) {
        console.log(response, "Archived Reports");
        dispatch(archivedReportsList(response?.data?.archived_reports || []));
      }
      return response;
    } catch (error) {
      toast.error(error.message, {  autoClose: false,  closeButton: true});
    }
  }
);

export const DeleteArchivedReport = createAsyncThunk(
  "deleteArchivedReport",
  async ({ reportId, companyId }, { dispatch }) => {
    try {
      const response = await deleteArchivedFinanceReport(reportId);
      if (response?.code === 1) {
        toast.success("Archived report deleted successfully");
        // Refresh the archived reports list
        dispatch(FetchArchivedReports(companyId));
      } else {
        toast.error(response?.message || "Failed to delete archived report");
      }
      return response;
    } catch (error) {
      toast.error(error.message || "Failed to delete archived report", { autoClose: false, closeButton: true});
    }
  }
);

export const { listing, details, totalCount, adminPercentile, teacher, listingTeacher, setting, venueList, itemDetail, archivedReportsList } =
  payment.actions;

export default payment.reducer;
